<section class="product-details">
  <div>
    <mat-checkbox
      class="product-details__apply-from-other"
      (change)="applyDetailsFromOtherProduct($event.checked)"
    >
      {{ 'inventory.product-details.apply-from-other.checkbox-title' | translate }}
    </mat-checkbox>
    @if (isApplyFromOtherChecked()) {
      <label class="product-details__search-box">
        {{ 'inventory.product-details.apply-from-other.search-label' | translate }}
        <div class="product-details__search-input-wrapper">
          <div class="product-details__icon-wrapper">
            <app-icon [icon]="ICON_NAMES.MAGNIFYING_GLASS" />
          </div>
          <input
            #searchInput
            class="product-details__search-input"
            [placeholder]="
              'inventory.product-details.apply-from-other.search-placeholder' | translate
            "
            [formControl]="searchInputFormControl"
          />
        </div>

        @if (foundItems().length > 0 && !isOtherDetailSelected()) {
          <div class="product-details__found-items-list">
            @for (item of foundItems(); track item.id) {
              <button class="product-details__found-item" (click)="loadDetails(item)">
                <span
                  appHighlight
                  [text]="item.productName"
                  [query]="query()"
                  highlightClass="product-details__highlighted-text"
                  class="product-details__name-text"
                >
                  {{ item.productName }}
                </span>
                <span class="product-details__upc-text">
                  {{ item.productUpc }}
                </span>
              </button>
            }
          </div>
        }
      </label>
    }
  </div>

  <table class="product-details__table apply-generic-form-field">
    <thead>
      <tr class="product-details__table-header-row">
        @for (header of HEADERS; track header) {
          @let isValue = header.valueKey ? true : false;
          <th
            class="product-details__table-header-cell"
            [class.product-details__dynamic-value]="header.isDynamic"
            [class.product-details__static-value]="isValue && !header.isDynamic"
          >
            @if (isValue) {
              {{ 'inventory.product-details.table.' + header.valueKey | translate }}
            }
          </th>
        }
      </tr>
    </thead>
    <tbody
      cdkDropList
      class="product-details__table-body"
      (cdkDropListDropped)="draggableDrop($event)"
    >
      @let errorsPrefix = 'inventory.productDetails.table.errors.';
      @for (group of detailRows(); track group) {
        <tr cdkDrag cdkDragBoundary="product-details__table-body" cdkDragLockAxis="y">
          <td class="product-details__btn-cell">
            <button
              class="product-details__icon-btn product-details__grip-btn"
              [disabled]="detailsCount() < 2"
              cdkDragHandle
            >
              <app-icon [icon]="ICON_NAMES.GRIP_VERTICAL" />
            </button>
          </td>

          <td class="product-details__form-field-cell">
            @let nameControl = group.controls.name;
            <mat-form-field
              class="product-details__form-field-el"
              appearance="outline"
              subscriptSizing="fixed"
            >
              <input matInput [formControl]="nameControl" required />
              @if (nameControl.invalid) {
                <mat-error class="product-details__form-field-error-text">
                  {{
                    (nameControl
                      | findFirstErrorKeyFromControl
                        : {
                            required: 'required',
                            maxlength: 'maxlength',
                            pattern: 'pattern',
                          }
                        : errorsPrefix + 'name.'
                      | async) ?? '' | translate
                  }}
                </mat-error>
              }
            </mat-form-field>
          </td>

          <td class="product-details__form-field-cell">
            <mat-form-field
              class="product-details__form-field-el"
              appearance="outline"
              subscriptSizing="fixed"
            >
              <mat-select [formControl]="group.controls.type">
                <mat-select-trigger>
                  {{
                    'inventory.product-details.table.data-types.' + group.controls.type.value
                      | translate
                  }}
                </mat-select-trigger>
                @for (type of DATA_TYPES; track type) {
                  <mat-option [value]="type">
                    {{ 'inventory.product-details.table.data-types.' + type | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>

          <td class="product-details__form-field-cell">
            <mat-form-field
              class="product-details__form-field-el"
              appearance="outline"
              subscriptSizing="fixed"
              [class.product-details__form-field-el--disabled]="
                group.controls.type.value !== PRODUCT_DETAIL_DATA_TYPE.NUMBER
              "
            >
              <mat-select [formControl]="group.controls.unit" required>
                @for (unit of UNITS; track unit) {
                  <mat-option [value]="unit">
                    {{ 'inventory.product-details.table.units.' + unit | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>

          <td class="product-details__form-field-cell">
            <mat-form-field
              class="product-details__form-field-el"
              appearance="outline"
              subscriptSizing="fixed"
            >
              @let valueControl = group.controls.value;
              @let typeValue = group.controls.type.value;
              @if (typeValue === PRODUCT_DETAIL_DATA_TYPE.NUMBER) {
                <input matInput [formControl]="valueControl" type="number" required />
              } @else if (typeValue === PRODUCT_DETAIL_DATA_TYPE.LOGIC) {
                <mat-select [formControl]="valueControl" required>
                  <mat-option value="true">
                    {{ 'inventory.product-details.table.logic-values.true' | translate }}
                  </mat-option>
                  <mat-option value="false">
                    {{ 'inventory.product-details.table.logic-values.false' | translate }}
                  </mat-option>
                </mat-select>
              } @else if (typeValue === PRODUCT_DETAIL_DATA_TYPE.COLOR) {
                <input matInput [formControl]="valueControl" type="color" required />
              } @else {
                <input matInput [formControl]="valueControl" type="text" required />
              }
              <mat-error class="product-details__form-field-error-text">
                {{
                  (valueControl
                    | findFirstErrorKeyFromControl
                      : {
                          required: 'required',
                          maxlength: 'maxlength',
                          pattern: 'pattern',
                        }
                      : errorsPrefix + 'value.'
                    | async) ?? '' | translate
                }}
              </mat-error>
            </mat-form-field>
          </td>

          <td class="product-details__btn-cell">
            <button class="product-details__icon-btn" (click)="deleteOption($index)">
              <app-icon [icon]="ICON_NAMES.TRASH_BIN_LIGHT" />
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>

  <button
    class="product-details__add-another-parameter-btn product-details__icon-btn"
    (click)="addProductDetail()"
    [disabled]="detailsCount() >= MAX_NUMBER_OF_DETAILS"
  >
    <app-icon [icon]="ICON_NAMES.ADD_ANOTHER_PURPLE_PLUS" />
    {{ 'inventory.product-details.add-another-parameter' | translate }}
  </button>
</section>
